import React, { useState } from "react";
import "./Nav.css";
import { useNavigate } from "react-router-dom";
import finalLogo from "../../Images/Production_logo.PNG";
import introVideo from "../../Video/new.mp4";
import Hamburger from "../Hamburger/Hamburger";
// import Loader from "../Loader/Loader";

function Nav() {
  const [showNavbar, setShowNavbar] = useState(false);
  // const [isVideoLoaded, setVideoLoaded] = useState(false);

  const handleShowNavbar = () => {
    // console.log("executed", showNavbar);
    setShowNavbar(!showNavbar);
  };

  // const handleVideoLoad = () => {
  //   // console.log("executed");
  //   setVideoLoaded(true);
  // }

  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/", { replace: true });
  };

  const onClickHandle = () => {
    navigate("/booking", { replace: true });
  };

  const handleOnGalleryClick = () => {
    navigate("/gallery", { replace: true });
  };

  const handleAnywhereClick = () => {
    if (window.innerWidth <= 600) {
      if (showNavbar) setShowNavbar(!showNavbar);
    }
  };

  const onClickContactHandle = () => {
    navigate("/contact", { replace: true });
  };

  return (
    <div className="navbar" onClick={handleAnywhereClick}>
      <div
        dangerouslySetInnerHTML={{
          __html: `
        <video
          loop
          muted
          autoplay
          playsinline
          src="${introVideo}"
          class="new-video"
        />,
      `,
        }}
      ></div>
      <div className="nav">
        <div className="left">
          <img
            src={finalLogo}
            alt="four seasons resort, jamshedpur"
            className="logo-image-size"
          />
        </div>
        <div className="menu-icon" onClick={handleShowNavbar}>
          <Hamburger />
        </div>
        <div className={`right ${showNavbar && "active"}`} id="navbar-list">
          <ul className="list">
            <li onClick={handleClick} className="r-list" id="r-list-home">
              Home
            </li>
            <li onClick={onClickHandle} className="r-list">
              Booking
            </li>
            <li onClick={handleOnGalleryClick} className="r-list">
              Gallery
            </li>
            <li className="r-list" onClick={onClickContactHandle}>
              Contact
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Nav;
